import React, { useEffect } from 'react';
import { sendScreenEvent } from '@useblu/blu-lytics';

import {
  FeedbackContainer,
  FeedbackImage,
  FeedbackTitle,
  FeedbackSubtitle,
} from '@/components/Template/Feedback';

import invalid from '@/assets/invalid.svg';

const Invalid: React.FC = () => {
  useEffect(() => {
    sendScreenEvent('link_blu_checkout_expired_view');
  }, []);

  return (
    <FeedbackContainer>
      <FeedbackImage src={invalid} alt="Imagem de não encontrado" />
      <FeedbackTitle>Ops! Link inválido</FeedbackTitle>
      <FeedbackSubtitle>
        Este link já foi utilizado ou está expirado. Fale com o lojista e
        solicite um novo.
      </FeedbackSubtitle>
    </FeedbackContainer>
  );
};

export default Invalid;
